import { Link } from 'react-router';
import { Icon } from '../atoms/Icon';
import UROLogo from '../atoms/UROLogo';
import PHTile from '../atoms/PHTile';

const ZEN_TILES = [
  { l: 'flux 1.1 ultra · 9:16',  f: 'rgba(255,126,103,.55)', t: 'rgba(255,77,141,.30)',  r: 9/16 },
  { l: 'gpt image 2 · 1:1',      f: 'rgba(255,77,141,.45)',  t: 'rgba(167,139,250,.25)', r: 1 },
  { l: 'veo 3 · 16:9',           f: 'rgba(99,102,241,.50)',  t: 'rgba(255,126,103,.25)', r: 16/9, k: 'video', d: '0:08' },
  { l: 'flux 1.1 ultra · 1:1',   f: 'rgba(255,126,103,.45)', t: 'rgba(255,77,141,.20)',  r: 1 },
  { l: 'kling 3 · 9:16',         f: 'rgba(99,102,241,.45)',  t: 'rgba(167,139,250,.20)', r: 9/16, k: 'video', d: '0:05' },
  { l: 'sdxl · 4:3',             f: 'rgba(255,77,141,.40)',  t: 'rgba(255,126,103,.20)', r: 4/3 },
];

const NAV_ITEMS = [
  { l: 'Zen', a: true },
  { l: 'Explore' },
  { l: 'Library' },
  { l: 'Studios' },
  { l: 'Brand DNA', soon: true },
  { l: 'API keys' },
];

function ZenMockupUI() {
  return (
    <div style={{
      borderRadius: 22, overflow: 'hidden', position: 'relative',
      background: '#0a0a0c', border: '1px solid rgba(255,255,255,.08)',
      boxShadow: '0 60px 120px -40px rgba(255,77,141,.30), 0 30px 80px -30px rgba(99,102,241,.25), 0 0 0 1px rgba(255,255,255,.03) inset',
    }}>
      {/* window chrome */}
      <div className="row" style={{ height: 38, padding: '0 14px', borderBottom: '1px solid rgba(255,255,255,.06)', gap: 12, background: 'rgba(255,255,255,.02)' }}>
        <span style={{ display: 'inline-flex', gap: 6 }}>
          {['#FF5F57', '#FEBC2E', '#28C840'].map(c => (
            <span key={c} style={{ width: 11, height: 11, borderRadius: '50%', background: c, opacity: .85 }}/>
          ))}
        </span>
        <div className="row gap-2 mono" style={{ marginLeft: 16, color: 'var(--text-4)', fontSize: 11 }}>
          <span style={{ width: 8, height: 8, borderRadius: 2, background: 'var(--grad)' }}/>
          Flux URO / zen
        </div>
      </div>

      <div className="zen-grid" style={{ display: 'grid', gridTemplateColumns: '220px 1fr', minHeight: 560 }}>
        {/* sidebar */}
        <aside style={{ borderRight: '1px solid rgba(255,255,255,.06)', padding: 16, background: 'rgba(255,255,255,.015)', position: 'relative' }}>
          <UROLogo size={18}/>
          <div style={{ marginTop: 24 }}>
            {NAV_ITEMS.map((it, i) => (
              <div key={i} className="row" style={{ height: 34, padding: '0 10px', borderRadius: 10, marginBottom: 4, gap: 10, background: it.a ? 'rgba(255,255,255,.06)' : 'transparent', color: it.a ? '#fff' : 'var(--text-3)', fontSize: 13, fontWeight: it.a ? 600 : 500, justifyContent: 'space-between' }}>
                <div className="row gap-3" style={{ alignItems: 'center' }}>
                  <span style={{ width: 14, height: 14, borderRadius: 4, background: it.a ? 'var(--grad)' : 'rgba(255,255,255,.08)' }}/>
                  {it.l}
                </div>
                {it.soon && <span style={{ fontSize: 9, color: '#C4B5FD', background: 'rgba(167,139,250,.12)', padding: '2px 6px', borderRadius: 999 }}>SOON</span>}
              </div>
            ))}
          </div>
          <div style={{ marginTop: 28 }}>
            <div className="eyebrow" style={{ fontSize: 10, marginBottom: 10 }}>Recent</div>
            {['cinematic product shots', 'founder portraits', 'app onboarding'].map((r, i) => (
              <div key={i} style={{ fontSize: 12, color: 'var(--text-3)', padding: '6px 8px', borderRadius: 8 }}>{r}</div>
            ))}
          </div>
          <div className="card" style={{ position: 'absolute', left: 16, bottom: 16, width: 'calc(100% - 32px)', padding: 12 }}>
            <div style={{ fontSize: 11, color: 'var(--text-3)' }}>Balance</div>
            <div style={{ fontSize: 18, fontWeight: 700, marginTop: 2 }}>$42.18</div>
            <div style={{ height: 4, background: 'rgba(255,255,255,.08)', borderRadius: 2, marginTop: 10, overflow: 'hidden' }}>
              <div style={{ width: '62%', height: '100%', background: 'var(--grad)' }}/>
            </div>
          </div>
        </aside>

        {/* main panel */}
        <div style={{ padding: 22, position: 'relative' }}>
          <div className="row" style={{ gap: 10, flexWrap: 'wrap' }}>
            <div className="row gap-3" style={{ height: 38, padding: '0 12px', borderRadius: 10, background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.08)', fontSize: 13, fontWeight: 600 }}>
              <span style={{ width: 14, height: 14, borderRadius: 4, background: 'var(--grad)' }}/>
              Flux 1.1 Ultra
              <span style={{ color: 'var(--text-4)', marginLeft: 4 }}>▾</span>
            </div>
            <div className="row gap-2" style={{ height: 38, padding: '0 12px', borderRadius: 10, background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.06)', fontSize: 12, color: 'var(--text-3)' }}>
              16:9 · 1024 · 4
            </div>
            <div className="row" style={{ marginLeft: 'auto', gap: 8 }}>
              <div className="chip" style={{ background: 'rgba(16,185,129,.10)', borderColor: 'rgba(16,185,129,.25)', color: '#6EE7B7' }}>
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#10B981' }}/>
                Streaming
              </div>
            </div>
          </div>

          <div style={{ marginTop: 14, padding: 14, borderRadius: 14, background: 'rgba(255,255,255,.03)', border: '1px solid rgba(255,255,255,.08)' }}>
            <div style={{ color: '#fff', fontSize: 14, lineHeight: 1.5 }}>
              A cinematic product shot of a matte black perfume bottle on wet stone, soft rim light,
              moody studio backdrop, shallow depth of field, 50mm.
            </div>
            <div className="row" style={{ marginTop: 12, justifyContent: 'space-between' }}>
              <div className="row gap-3" style={{ color: 'var(--text-3)', fontSize: 12 }}>
                <span className="row gap-2"><span style={{ width: 14, height: 14, borderRadius: 4, background: 'rgba(255,255,255,.06)' }}/>Reference</span>
                <span className="row gap-2"><span style={{ width: 14, height: 14, borderRadius: 4, background: 'rgba(255,255,255,.06)' }}/>Brand DNA</span>
              </div>
              <button className="btn btn-primary btn-sm" style={{ height: 32 }}>Generate · $0.016</button>
            </div>
          </div>

          <div className="zen-grid-tiles" style={{ marginTop: 18, display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 12 }}>
            {ZEN_TILES.map((t, i) => (
              <PHTile key={i} label={t.l} kind={t.k || 'image'} from={t.f} to={t.t} ratio={t.r} dur={t.d}/>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ZenSection() {
  return (
    <section id="zen">
      <div className="container">
        <div className="eyebrow" style={{ marginBottom: 14 }}>The Zen workspace</div>
        <h2 className="h2" style={{ maxWidth: '18ch' }}>
          One interface for <span className="grad-text">everything.</span>
        </h2>
        <p className="lede" style={{ marginTop: 18, maxWidth: '60ch' }}>
          Zen is your AI creation workspace. Pick a model, write a prompt,
          and generate. Results stream in real time.
        </p>

        <div style={{ marginTop: 48, position: 'relative' }}>
          <ZenMockupUI/>
        </div>

        <div style={{ marginTop: 28, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {['Real-time generation', '50+ models in one place', 'Full generation history'].map(p => (
            <span key={p} className="chip" style={{ height: 32, padding: '0 14px' }}>
              <Icon.check size={12} color="#10B981"/> {p}
            </span>
          ))}
          <Link to="/register" className="btn btn-ghost btn-sm" style={{ marginLeft: 'auto' }}>
            Try Zen for free <Icon.arrow size={12}/>
          </Link>
        </div>
      </div>
    </section>
  );
}
